module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('div', {
    staticClass: "SOM_titre"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv1-001"
    }
  }, [_vm._v("Bible Versions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("Select bibliographies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-002"
    }
  }, [_vm._v("General introduction to Haggai, Zechariah and Malachi")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-003"
    }
  }, [_vm._v("Haggai")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-004"
    }
  }, [_vm._v("Zechariah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-005"
    }
  }, [_vm._v("Malachi")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6"
    }
  }, [_vm._v("General introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-006"
    }
  }, [_vm._v("1. Historical background")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-007"
    }
  }, [_vm._v("2. The Book of the Twelve")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-008"
    }
  }, [_vm._v("3. The theology of Haggai, Zechariah and Malachi")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_vm._v("Haggai")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-009"
    }
  }, [_vm._v("1. Title and text")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-010"
    }
  }, [_vm._v("2. The prophet Haggai")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-011"
    }
  }, [_vm._v("3. Historical background")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-012"
    }
  }, [_vm._v("4. Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-013"
    }
  }, [_vm._v("5. Date and occasion of writing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-014"
    }
  }, [_vm._v("6. Audience")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-015"
    }
  }, [_vm._v("7. Form and structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-016"
    }
  }, [_vm._v("8. Literary style")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-017"
    }
  }, [_vm._v("9. Intertextuality")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-018"
    }
  }, [_vm._v("10. Message")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#niv1-019"
    }
  }, [_vm._v("11. Theological concerns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Analysis")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_spart"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. First message: Haggai’s challenge to covenant renewal (1:1‒15)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap1#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Superscription (1:1)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap1#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The call to reconsider priorities (1:2–6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap1#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The call to rebuild the temple (1:7–11)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap1#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. The response of the people (1:12–15)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Second message: the promise of restoration (2:1‒9)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap2#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Introduction (2:1–2)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap2#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Present condition of the temple (2:3–5)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap2#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Promise of future glory for the temple (2:6–9)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Third message: the call to holiness (2:10‒19)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap3#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Introduction: Date and prophetic word formulas (2:10)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap3#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Haggai requests Torah instructions from the priests (2:11–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap3#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The call to reﬂect upon current conditions (2:15–19)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Fourth message: Zerubbabel, Davidic servant and signet ring (2:20‒23)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap4#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Introduction: Date and prophetic word formulas (2:20)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap4#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Warning of divine judgment against the nations (2:21–22)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap4#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. God’s appointment of Zerubbabel as leader (2:23)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zechariah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Title and text")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The prophet Zechariah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Historical background")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Date and occasion of writing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Audience")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Literary style and structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Understanding visionary literature")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Zechariah and typology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Message")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Theological concerns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Analysis")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_spart"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Prelude: a call to return to the Lord (1:1‒6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap1#niv1-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Superscription (1:1)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap1#niv1-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Prologue: The call to return to God… for a change (1:2–6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Zechariah’s visions (1:7 ‒ 6:15)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. A man among the myrtle trees (1:7–17)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Four horns and four blacksmiths (1:18–21 ["), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT ")]), _vm._v("2:1–4])")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2#niv1-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. A man with a measuring line (2:1–5 ["), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT ")]), _vm._v("2:5–9])")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2#niv1-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. The exiles are called home (2:6–13 ["), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT ")]), _vm._v("2:10–17])")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2#niv1-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. Cleansing for the high priest (3:1–10)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2#niv1-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. A gold lampstand and two olive trees (4:1–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2#niv1-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. A ﬂying scroll (5:1–4)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2#niv1-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H. A woman in a basket (5:5–11)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2#niv1-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Four chariots (6:1–8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap2#niv1-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. The crowning of high priest Joshua (6:9–15)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Zechariah’s messages (7 – 8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv1-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Zechariah receives a delegation from Bethel (7:1–7)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. The delegation raises a question about fasting (vv. 1-3)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. The prophet’s initial response (vv. 4–7)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv1-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The call to covenant justice (7:8–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. The admonition for social justice rejected by the Hebrew ancestors (vv. 8–12)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. God’s punishment: exile (vv. 13–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv1-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. God’s promise of restoration for Jerusalem (8:1–8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. God’s zeal for Zion (vv. 1–2)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. God’s return to Zion (v. 3)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. God restores peace and safety to Jerusalem (vv. 4–5)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iv. God will bring his people back from exile and repopulate Jerusalem (vv. 6–8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv1-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. God’s promises to deliver and restore the remnant of Israel (8:9–23)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. The prophet’s exhortation to rebuild the temple (vv. 9–13)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. God’s plans for Jerusalem (vv. 14–17)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. Joyful fasting (vv. 18–19)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap3#niv2-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iv. The nations will seek the Lord in Jerusalem (vv. 20–23)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Zechariah’s oracles (9 – 14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv1-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. First oracle (9 – 11)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv2-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. Judgment against Israel’s enemies (9:1–8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv2-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. Zion’s coming king (9:9–13)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv2-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. The Lord will appear and deliver his people (9:14–17)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv2-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iv. The Lord will restore his people (10:1 – 11:3)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Lord will care for his ﬂock (10:1–5)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The Lord will restore Israel (10:6-12)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Lament over the destruction of Lebanon (11:1-3)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv2-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("v. The two shepherds (11:4–17)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Zechariah’s commission (vv. 4–6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The sign-act of the shepherds’ staffs (vv. 7-14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Zechariah commissioned a second time (vv. 15-17)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv1-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Second oracle (12 – 14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv2-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. Future deliverance of Jerusalem (12:1–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. God defends Judah and Jerusalem (vv. 1-9)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. A spirit of grace poured out, and mourning over the pierced one (vv. 10-14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv2-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. A fountain of cleansing (13:1–6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv2-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii. The scattering of the sheep (13:7–9)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv2-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iv. The Lord will rule the earth (14:1–21)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Lord defends Jerusalem (vv. 1-3)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The Lord comes to the Mount of Olives (vv. 4-5)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. The Lord’s unique day (vv. 6-8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. The ghastly plague against people and animals (vv. 9-15)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. Celebration of the Feast of Tabernacles (vv. 16-19)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv3"
  }, [_c('span', {
    attrs: {
      "href": "#/p2sp3chap4#niv3-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f. Holiness in Jerusalem (vv. 20-21)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malachi")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Title and text")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The prophet Malachi")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Historical background")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Date and occasion of writing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Audience")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Literary style")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Intertextuality")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Message")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1#niv1-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Theological concerns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Analysis")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_spart"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. First disputation: YHWH’s love for Israel (1:1–5)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap1#niv1-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Superscription (1:1)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap1#niv1-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. YHWH’s love for Israel (1:2–5)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Second disputation: indictment of faithless priests (1:6 – 2:9)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap2#niv1-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. YHWH dishonoured by improper worship (1:6–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap2#niv2-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. Contemptible animal sacriﬁces condemned (1:6–10)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap2#niv2-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. YHWH’s name profaned (vv. 11–14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap2#niv1-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Insolent priests rebuked (2:1–9)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap2#niv2-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i. Threat of curse for dishonouring YHWH (2:1–3)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap2#niv2-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii. YHWH’s covenant deﬁled by faulty instruction (2:4–9)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Third disputation: indictment of faithless people (2:10–16)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap3#niv1-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. YHWH’s covenant profaned by disobedience (2:10–12)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap3#niv1-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Covenant of marriage profaned by divorce (2:13–16)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Fourth disputation: YHWH’s messenger of judgment (2:17 – 3:5)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap4#niv1-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. YHWH’s justice challenged (2:17)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap4#niv1-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. YHWH will come to his temple (3:1–4)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap4#niv1-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. YHWH’s judgment (3:5)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Fifth disputation: the call to serve YHWH (3:6–12)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap5#niv1-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The call to repentance (3:6–7)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap5#niv1-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The call to bring the whole tithe (3:8–12)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Sixth disputation: the day of YHWH (3:13 – 4:3 [Mt 3:21])")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap6#niv1-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Obedience to YHWH challenged (3:13–15)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap6#niv1-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Obedience to YHWH vindicated (3:16–18)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap6#niv1-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The Day of YHWH – judgment and vindication (4:1–3 ["), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT ")]), _vm._v("3:19–21])")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Appendices (4:4–6 [Mt 3:22–24])")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap7#niv1-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Charge to obey the law of Moses (4:4 ["), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT ")]), _vm._v("3:22])")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p3sp3chap7#niv1-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Elijah and the Day of YHWH (4:5–6 ["), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT ")]), _vm._v("3:23–24]")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Tyndale Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/TOTC_TNTC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tyndale Commentary Volumes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/collec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident12#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 66
// module chunks = 0